var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mibo-video-player"},[_c('video',{ref:"video",staticClass:"mibo-video-player__el",attrs:{"controls":"","playsinline":"","poster":_vm.poster || undefined}}),(_vm.errorMsg)?_c('div',{staticClass:"mibo-video-player__error"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }